import React, { useState } from "react";
import { useHistory } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import { createProviderIntegration } from "../../../redux/actions/integrationsActions";
import AppWizard from "../../../shared/appWizard/appWizard";
import SuccessBox from "../../../shared/successBox/successBox";
import { clouds } from "../../../utils/icons";
import Ns1Form from "./ns1Form";
import { PROVIDERS } from "../../../consts/general";
import "./ns1Integration.scss";

const Ns1Integration = () => {
  const history = useHistory();
  const dispatch = useDispatch();
  const [wizardState, setWizardState] = useState({});
  const [submitDisabled, setSubmitDisabled] = useState(true);
  const [loadingSubmit, setLoadingSubmit] = useState(false);
  const isDarkTheme = useSelector(
    (state) => state.userPreferencesReducer.themeDark
  );

  const configWizard = [
    {
      step_title: "Setup",
      step_description: "NS1 Integration setup",
      content_title: "NS1 Integration",
      content: (
        <Ns1Form
          wizardState={wizardState}
          setWizardState={setWizardState}
          setSubmitDisabled={setSubmitDisabled}
        />
      ),
      valid: true,
      beforeNextStep: async () => {
        setLoadingSubmit(true);
        const req = await dispatch(
          createProviderIntegration(PROVIDERS.ns1, {
            name: wizardState?.name,
            token: wizardState?.token,
          })
        );
        setLoadingSubmit(false);
        if (!req?.ok) {
          throw new Error(`Failed to create NS1 integration.`);
        }
      },
    },
    {
      step_title: "Completion",
      step_description: "",
      content_title: "Integration Created!",
      content: (
        <SuccessBox
          setSubmitDisabled={setSubmitDisabled}
          subTitle="The Resources from the Integration will take up to one hour to appear in the inventory"
          doesTakeTime
        />
      ),
      valid: true,
    },
  ];

  return (
    <div className="NS1Integration">
      <AppWizard
        iconSrc={clouds(PROVIDERS.ns1, isDarkTheme)}
        loadingSubmit={loadingSubmit}
        configWizard={configWizard}
        handleClose={() => history.goBack()}
        submitDisabled={submitDisabled}
        setSubmitDisabled={setSubmitDisabled}
        handleSubmit={() => history.push("/integrations")}
      />
    </div>
  );
};

export default Ns1Integration;
